module.exports = __webpack_public_path__ + "assets/img/32_647.99b9b676.jpg";